/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecretRequest } from '../../models/secret-request';
import { SecretResponse } from '../../models/secret-response';

export interface UpsertSecret$Params {
  'Active-Tenant-Identifier': string;
  secretName:
    | 'acoustic_settings'
    | 'acoustic_databaseid'
    | 'acoustic_clientid'
    | 'acoustic_clientsecret'
    | 'acoustic_refreshtoken'
    | 'acoustic_pod'
    | 'braze_rest_api_key'
    | 'android_app_api_key'
    | 'ios_app_api_key'
    | 'web_app_api_key'
    | 'pp5_user_search_api_key';
      body: SecretRequest
}

export function upsertSecret(http: HttpClient, rootUrl: string, params: UpsertSecret$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretResponse>> {
  const rb = new RequestBuilder(rootUrl, upsertSecret.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('secretName', params.secretName, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecretResponse>;
    })
  );
}

upsertSecret.PATH = '/secrets/{secretName}';
